import React from 'react';
import { Breadcrumb  } from 'antd';
import { RightOutlined, ExportOutlined } from '@ant-design/icons';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { BackIcon } from '../CustomIcons/CustomIcons';
import { formatText } from '../../utils';
import { ProductContext } from '../../contexts/ProductContext';
import { BrandDeviceCateObject } from '../../Constants';
import _ from 'lodash';

const extraFunctions = [
    {
        name: 'Upload CSV To Cart',
        icon: <ExportOutlined />,
        link: '/upload-csv-to-cart'
    },
    {
        name: 'Scan Barcode To Cart',
        icon: <ExportOutlined />,
        link: '/scan-barcode-to-cart'
    },    
    // {
    //     name: 'Orders',
    //     icon: null,
    //     link: '/your-account/your-orders'
    // },    
    // {
    //     name: 'Invoices',
    //     icon: null,
    //     link: '/your-account/your-invoices'
    // },
    // {
    //     name: 'Returns',
    //     icon: null,
    //     link: '/your-account/returns'
    // },
    {
        name: 'Help',
        icon: null,
        link: '/help'
    }
]

const checkBread = [
    {
        name: 'Shop',
        link: '/shop'
    },
    {
        name: 'Your Account',
        link: '/your-account'
    },
    {
        name: 'Your Invoices',
        link: '/your-account/your-invoices'
    },
    {
        name: 'Your Orders',
        link: '/your-account/your-orders'
    },  
    {
        name: 'Back Orders',
        link: '/your-account/back-orders'
    },
    {
        name: 'Service Requests',
        link: '/your-account/returns'
    },                
    {
        name: 'Brands',
        link: '/shop/brands'
    },
    {
        name: 'Categories',
        link: '/shop/categories'
    },
    {
        name: 'Compatibility',
        link: '/shop/compatibility'
    },
    {
        name: 'Manage Users',
        link: '/your-account/manage-users'
    }
]

const BreadCrumbBar = () => {
    const [layerLink, setLayerLink] = React.useState<Array<{name: string, link: string}>>([]);
    const location = useLocation();
    const history = useHistory();
    const {productState} = React.useContext(ProductContext);

    React.useEffect(() => {
        if(location) {
            let masterList:Array<BrandDeviceCateObject> = [];
            let link = '';

            if(location.pathname.includes('brands')) {
                masterList = productState.brands;
                link = '/brands';
            } else if(location.pathname.includes('categories')) {
                masterList = productState.categories;
                link = '/categories';
            } else if(location.pathname.includes('device-vendors')) {
                masterList = productState.deviceVendors;
                link = '/device-vendors';
            }
            
            const setupArray:Array<{name: string, link: string}> = [];
            const layerArray = _.sortedUniq(location.pathname.split('/'));

            let brandSpecialFound: number = 0;
            
            layerArray.forEach(e => {
                if(e === '') {
                    setupArray.push({
                        name: 'Home',
                        link: '/'
                    })
                } else if (e === 'returns') {
                    setupArray.push({
                        name: 'Service Requests',
                        link: '/your-account/returns'
                    })
                } else if (e.startsWith("brand-")) {
                    brandSpecialFound = 1;
                } else if (brandSpecialFound === 1) {
                    let check = _.find(productState.brands, (value) => {
                        return formatText(value.link) === e
                    })
                    if(check) {
                        setupArray.push({
                            name: check.name,
                            link: '/shop/brands/' + check.link
                        })
                    }
                    brandSpecialFound = 2;
                } else if (brandSpecialFound === 0) {
                    // check bread for special
                    let checkTest = _.find(checkBread, (value) => {
                        return formatText(value.name) === e;
                    })

                    if(checkTest) {
                        setupArray.push({
                            name: checkTest.name,
                            link: checkTest.link
                        })
                    } else {
                        if(masterList.length > 0) {
                            let check = _.find(masterList, (value) => {
                                return formatText(value.link) === e
                            })

                            if(check) {
                                setupArray.push({
                                    name: check.name,
                                    link: '/shop' + link + '/' + check.link
                                })
                            } else {
                                let productExt = _.find([...productState.productIdToProduct.values()], (p) => {
                                    return formatText(p.product.name) === e
                                })
                                if(productExt) {
                                    setupArray.push({
                                        name: productExt.product.name,
                                        link: ''
                                    })
                                } else {
                                    setupArray.push({
                                        name: e.toLocaleUpperCase(),
                                        link: ''
                                    })
                                }
                            }
                        } else {
                            let productExt = _.find([...productState.productIdToProduct.values()], (p) => {
                                return formatText(p.product.name) === e
                            })
                            if(productExt) {
                                setupArray.push({
                                    name: productExt.product.name,
                                    link: ''
                                })
                            } else {
                                setupArray.push({
                                    name: e.replaceAll('-', ' '),
                                    link: ''
                                })
                            }
                        }
                    }
                }
            });
            setLayerLink(setupArray);
        }
    }, [location, productState.productIdToProduct, productState.brands, productState.categories, productState.deviceVendors])
    
    return (
        <div className='breadcrumb-bar'>
            <div className='content-wrapper flexSpaceBetween'>
                <div className='flexCenter'>
                    {
                        layerLink.length > 1 && <>
                        <div className='backButton' onClick={() => {history.goBack()}}>
                            <BackIcon/>
                            Back
                        </div>
                        <Breadcrumb separator={<RightOutlined/>}>
                            {
                                layerLink.map((v, k) => {
                                    if(v.link === '' || k === layerLink.length - 1) {
                                        return <Breadcrumb.Item key={k} className='capitalize'>{v.name === 'returns' ? 'Service Requests' : v.name}</Breadcrumb.Item>
                                    } else {
                                        return  <Breadcrumb.Item key={k} className='capitalize'>
                                                    <Link to={v.link}>{v.name}</Link>
                                                </Breadcrumb.Item>
                                    }
                                })
                            }
                        </Breadcrumb>
                        </>
                    }
                    
                </div>
                <div className='otherFunctions'>
                    <span><a href="https://www.flipsnack.com/cellnet/" target="_blank" rel="noopener noreferrer">Catalogues</a></span>
                    {
                        extraFunctions.map((value, key) => {
                            return (
                                <span key={key}><Link to={value.link}>{value.icon}{value.name}</Link></span>
                            )
                        })
                    }
                </div>
            </div>
        </div>
  );
}

export default BreadCrumbBar;

    